<script lang="ts" setup>
import SpinnerIcon from '~/assets/icons/preloader/spinner.svg'
</script>

<template>
  <div class="spinner-container">
    <div class="spinner">
      <SpinnerIcon />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinner-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  background-color: $bg_page;
}
.spinner {
  margin: auto;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  animation-name: spin;
  animation-duration: 900ms;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.53, 0.21, 0.29, 0.67);
}
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}
@keyframes spin {
  0% { -webkit-transform: rotate(0deg);}
  100% { -webkit-transform: rotate(360deg); }
}
</style>
